import React, { ReactNode } from 'react'
import { ProductAnalyticsContext } from 'features/product-analytics/ProductAnalyticsProvider'
import { noop } from 'lodash'

export default function SkeletonAnalyticsProvider({ children }: { children: ReactNode }) {
  return (
    <ProductAnalyticsContext.Provider
      value={{
        identify: noop,
        trackEvent: noop,
        reset: noop,
      }}
    >
      {children}
    </ProductAnalyticsContext.Provider>
  )
}
